import usePrepayment from '@mpc/common/src/model/Prepayment';
import React, { useState } from 'react';
import { Space, Button } from '@bedrock/components';
import { Check } from '@bedrock/icons-react';
import { prepaymentOutsourceUploadInvoice } from 'services/api';
import { createAsyncAction }  from '../../../Drawer/Actions/utils';
import type { FormInstance } from '@bedrock/components/lib/Form/util';

const OutPlannerConfirms = ({ form }: { form: FormInstance }) => {
  const [loading, setLoading] = useState(false);
  const { detail, loadDetail } = usePrepayment();

  const refreshListDetail = async () => {
    loadDetail();
  }

  const plannerPass = () => {
    createAsyncAction(loading, setLoading, refreshListDetail)(async () => {
      const { invoice_info } = await form.validateFields()
      await prepaymentOutsourceUploadInvoice({
        demand_id: detail?.base_info?.demand_id,
        prepayment_id: detail?.base_info?.id,
        invoice_belong_area: invoice_info?.invoice_belong_area,
        is_oversea_invoice: invoice_info?.is_oversea_invoice,
        invoice_list: invoice_info?.invoice_list,
      });
    })
  };

  return (
    <Space style={{ justifyContent: 'flex-end' }}>
      {detail?.permission_info?.can_upload_invoice && (
        <Button loading={loading} type="primary" onClick={plannerPass} icon={<Check />}>
          提交
        </Button>
      )}
    </Space>
  );
};

export default OutPlannerConfirms;
